import axios from "axios";
import queryString from "query-string";
import {middlewareRequest, middlewareResponse, middlewareResponseError,} from "./config";

const requestImage = axios.create({
  baseURL: "",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    serialize: (params) =>
      queryString.stringify(params, { arrayFormat: "comma" }),
  },
});

requestImage.interceptors.request.use(middlewareRequest, (error) =>
  Promise.reject(error)
);

requestImage.interceptors.response.use(
  middlewareResponse,
  middlewareResponseError
);

const imageApi = (options) => {
  return requestImage({
    ...options,
    headers: { "Accept-Language": "vi", ...options.headers },
  });
};

export default imageApi;
